import { isValid as t } from "date-fns";

import { startOfToday as s, startOfWeek as e, startOfMonth as i, stubFalse as h, identity as n, call as a, parseValue as r, getInputValueError as d, format as o, findDayNot as l, parse as c, addDays as _, addYears as u, addMonths as f, startOfYear as B, endOfYear as g, endOfMonth as m, endOfWeek as T } from "../utils/index.js";

import { DEFAULT_FORMAT as p, EMPTY_DATE_VAL as b } from "../constants/index.js";

const D = t => (s, e) => (e.preventDefault(), t(s, e)), S = D((t => t.select(t.intendedTs))), w = t => D((s => s.intend((s => _(s, t))))), y = t => D((s => s.intend(t))), C = t => D(((s, e) => s.intend((s => (e.shiftKey ? u : f)(s, t)), e.shiftKey ? t > 0 ? B : g : t > 0 ? i : m))), E = {
    ArrowUp: w(-7),
    ArrowDown: w(7),
    ArrowLeft: w(-1),
    ArrowRight: w(1),
    Home: y(e),
    End: y(T),
    PageUp: C(-1),
    PageDown: C(1),
    Enter: S,
    " ": S
};

class R {
    ids;
    _shouldRun=!1;
    _SUBS=[];
    _inBatch=0;
    format=p;
    opened=!1;
    inline=!1;
    disableFuture=!1;
    disablePast=!1;
    selectedTs=b;
    intendedTs=s();
    intendedTsFirstDay=e(i(this.intendedTs));
    isDateDisabled=h;
    onChange=n;
    onError=n;
    transformBeforeChange=n;
    searchValue="";
    errorMessage="";
    constructor({labelId: t, idPrefix: s}) {
        this.ids = {
            input: s + "input",
            monthYear: s + "my",
            label: t
        };
    }
    _startBatch() {
        this._inBatch++;
    }
    _endBatch() {
        0 == --this._inBatch && this._shouldRun && (this._shouldRun = !1, this._SUBS.forEach(a));
    }
    _run() {
        this._shouldRun = !0;
    }
    on=t => (this._SUBS.push(t), () => this._SUBS.splice(this._SUBS.indexOf(t), 1));
    toggle(t) {
        const s = t ?? !this.opened;
        s !== this.opened && (this._startBatch(), this.opened = s, this._run(), this._endBatch());
    }
    set({value: s = b, disablePast: e = !1, disableFuture: i = !1, inline: a = !1, isDateDisabled: d = h, onChange: o = n, onError: l = n, transformBeforeChange: _ = n, format: u = p}) {
        return this._startBatch(), this.transformBeforeChange = _, this.disableFuture = i, 
        this.disablePast = e, this.onError = l, this.onChange = o, u !== this.format && (this.format = u), 
        a !== this.inline && (this.inline = a, this._run()), d !== this.isDateDisabled && (this.isDateDisabled = d, 
        this._run()), this._selectRaw(r(s, u, c, t), !0) && this._syncSearchValue(), this._endBatch(), 
        this;
    }
    _selectRaw(t, s = !1) {
        if (t !== this.selectedTs) {
            if (this._startBatch(), t === b) this.selectedTs = b, this._run(); else if (this.intend(t, void 0, s)) {
                const t = d(this.intendedTs, this.disablePast, this.disableFuture);
                !s && t || (this.selectedTs = this.intendedTs, this._run()), this._setErrorMessage(t);
            }
            return this._endBatch(), !0;
        }
        return !1;
    }
    _callChangeHandler() {
        this.onChange(this.selectedTs === b ? b : this.transformBeforeChange(this.selectedTs, o, this.format));
    }
    _setErrorMessage(t) {
        t !== this.errorMessage && (this._startBatch(), this.errorMessage = t, this.onError(t), 
        this._run(), this._endBatch());
    }
    select(t) {
        this._startBatch(), this._selectRaw(t) && (this._syncSearchValue(), this._callChangeHandler(), 
        this.toggle(!1)), this._endBatch();
    }
    _syncSearchValue() {
        const t = this.selectedTs ? o(this.selectedTs, this.format) : "";
        t !== this.searchValue && (this._startBatch(), this.searchValue = t, this._run(), 
        this._endBatch());
    }
    intend(t, s, h = !1) {
        const n = "function" == typeof t ? t(this.intendedTs) : t, a = "function" == typeof s ? s(n) : s ?? n, r = l(n, a, h ? () => !1 : this.isDateDisabled, n < (this.intendedTs || 0) ? -1 : 1);
        return void 0 !== r && (r !== this.intendedTs && (this._startBatch(), this.intendedTs = r, 
        this.intendedTsFirstDay = e(i(r)), this._run(), this._endBatch()), !0);
    }
    handlers={
        keyDown: t => E[t.key]?.(this, t),
        input: s => {
            this._startBatch(), this.searchValue = s;
            let e = "";
            if (s) {
                let i = 0;
                const h = c(s, this.format);
                t(h) ? (i = +h, e = d(i, this.disablePast, this.disableFuture)) : e = "Invalid date", 
                !e && this._selectRaw(i) && this._callChangeHandler();
            } else this._selectRaw(b) && this._callChangeHandler();
            this._setErrorMessage(e), this._run(), this._endBatch();
        }
    };
}

export { R as default };
//# sourceMappingURL=basic.js.map
